export default __webpack_public_path__ + "0cd7466e89de9d9b641a8aca33d9708a.svg";